// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"DropdownMenu_dropdownContainer__232n7"};